





























import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { FormatMixin } from '@/mixins/FormatMixin';
import Multiselect from 'vue-multiselect';
import { BaseMixin } from '@/mixins/BaseMixin';
import { CheckIcon } from 'vue-feather-icons';
import { PermissionMixin } from '@/mixins/PermissionMixin';

@Component({
  name: 'antragsbuch-column-select',
  components: { Multiselect, CheckIcon },
})
export default class AntragsbuchColumnSelect extends mixins(
  BaseMixin,
  FormatMixin,
  PermissionMixin,
) {
  get options() {
    const columns = [
      'tasks',
      'customer',
      'product',
      'tags',
      'user',
      'value',
      'jahresNettoBeitrag',
      'quantity',
      'type',
      'antragsbuchData.submittedAt',
      'antragsbuchData.isArchived',
      'antragsbuchData.policyStartAt',
      'antragsbuchData.policyEndAt',
      'antragsbuchData.vnr',
      'antragsbuchData.bonus',
      'antragsbuchData.kvmob',
      'antragsbuchData.lvbsu',
    ];

    if (this.hasAgencyPermission('relativePolicies')) {
      columns.push('relativeValue');
    }
    return columns;
  }

  get selectedColumns(): string[] {
    return this.$store.state.PreferencesModule.antragsbuchColumns;
  }

  isSelected(column: string) {
    return this.selectedColumns.includes(column);
  }

  mapColumnName(id: string) {
    const map: Record<string, string> = {
      'tasks': 'Tasks',
      'customer': 'Kunde',
      'product': 'Produkt',
      'user': 'Mitarbeiter',
      'value': this.agency.wording?.value || 'Bewertung',
      'jahresNettoBeitrag': 'Jahresnettobeitrag',
      'quantity': 'Stückzahl',
      'tags': 'Tags',
      'type': 'Art',

      'antragsbuchData.submittedAt': 'Antragsdatum',
      'antragsbuchData.isArchived': 'Archiviert',
      'antragsbuchData.policedAt': 'Versichert am',
      'antragsbuchData.policyStartAt': 'Versicherungsbeginn',
      'antragsbuchData.policyEndAt': 'Versicherungsablauf',
      'antragsbuchData.vnr': 'VNR',
      'antragsbuchData.bonus': 'Prämie gem. Zahlweise',
      'antragsbuchData.kvmob': 'KV MOB',
      'antragsbuchData.lvbsu': 'LV-Beitragssumme',
    };
    return map[id];
  }

  updateSelectedColumns(columns: string[]) {
    console.log(columns);
    this.$store.commit('PreferencesModule/updateAntragsbuchColumns', columns);
  }
}
